<template>
	<div class="my-8">
		<h3 class="mb-4 text-lg font-normal text-neutral-800">
			{{ $t('personality_results.how_to_use.section.heading') }}
		</h3>

		<div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
			<HowToUseBox
				v-for="item in items"
				:key="item.id"
				:icon-component="item.iconComponent"
				:heading="item.heading"
				:content="item.content"
			/>
		</div>
	</div>
</template>

<script>
import { HowToUseBox } from './_internals'
import { IconDialogue, IconFile, IconUser } from '~/components/Icons'

export default {
	name: 'PersonalityHowToUse',
	components: {
		HowToUseBox
	},
	data() {
		return {
			items: [
				{
					id: 'job_description_alignment',
					iconComponent: IconFile,
					heading: this.$t(
						'personality_results.how_to_use.job_description_alignment.heading'
					),
					content: this.$t(
						'personality_results.how_to_use.job_description_alignment.content'
					)
				},
				{
					id: 'candidate_fit',
					iconComponent: IconUser,
					heading: this.$t(
						'personality_results.how_to_use.candidate_fit.heading'
					),
					content: this.$t(
						'personality_results.how_to_use.candidate_fit.content'
					)
				},
				{
					id: 'interview_questions',
					iconComponent: IconDialogue,
					heading: this.$t(
						'personality_results.how_to_use.interview_questions.heading'
					),
					content: this.$t(
						'personality_results.how_to_use.interview_questions.content'
					)
				}
			]
		}
	}
}
</script>
